import React, { useState } from "react";
import PendingApprovalTable from "./PendingApprovalTable";
import { SimpleDropdown } from "../../common/SimpleDropdown";

const PendingApprovalSection = () => {
  const [filterByRole, setFilterByRole] = useState("all");

  return (
    <div className="rounded-3xl bg-transparent">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-jp-accent-ink text-sm font-bold uppercase tracking-widest">
          PENDING APPROVAL
        </h2>

        <div className="flex items-center gap-6 text-sm text-jp-ink">
          <div className="flex items-center gap-2">
            <span>Filter by role</span>
            <SimpleDropdown
              value={filterByRole}
              onChange={(val) => setFilterByRole(val)}
              options={[
                { value: "all", label: "All" },
                { value: "coach", label: "Coach" },
                { value: "scout", label: "Scout" },
                { value: "player", label: "Player" },
              ]}
              placeholder="All"
              variant="admin"
            />
          </div>
        </div>
      </div>

      <PendingApprovalTable filterByRole={filterByRole} />
    </div>
  );
};

export default PendingApprovalSection;
